module.exports = __webpack_public_path__ + "img/PK.659714c9.png";